import cx from 'classnames';
import _ from 'lodash';
import React from 'react';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import styled from 'styled-components';

export const Wrapper = (
  props: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
): React.ReactElement => <div className='d-flex align-items-center' {...props} />;

export const Pin = styled(Badge)`
  background-color: var(--white15);
  color: #f7f7f7;
  padding: 8px;
`;

export const Favorite = ({
  className,
  inFavoriteList = false,
  onClick,
  ...props
}: React.HTMLAttributes<HTMLButtonElement> & { inFavoriteList?: boolean }): React.ReactElement => (
  <button
    type='button'
    key={`${inFavoriteList ? 1 : 2}`}
    className={cx(className, 'x-pseudo p-4px')}
    onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
      event.stopPropagation();
      event.preventDefault();

      onClick?.(event);
    }}
    {...props}
  >
    {inFavoriteList ? (
      <span>
        <i className='fas fa-star' style={{ width: 20, height: 20 }} />
      </span>
    ) : (
      <span>
        <i className='far fa-star' style={{ width: 20, height: 20 }} />
      </span>
    )}
  </button>
);

export const CheckIn = ({
  className,
  checkedUser,
  onClick,
  ...props
}: React.HTMLAttributes<HTMLButtonElement> & { checkedUser?: string }): React.ReactElement => (
  <button
    type='button'
    key={`${checkedUser ? 1 : 2}`}
    className={cx(className, 'x-pseudo p-4px')}
    {...props}
  >
    {checkedUser ? (
      <div>
        <OverlayTrigger
          placement='bottom'
          overlay={<Tooltip id={_.uniqueId('tooltip')}>{`Checked-in by: ${checkedUser}`}</Tooltip>}
        >
          <span>
            <i className='fa fa-thumbs-up' style={{ width: 20, height: 20 }} />
          </span>
        </OverlayTrigger>
      </div>
    ) : (
      <span>
        <i className='far fa-thumbs-up' style={{ width: 20, height: 20 }} />
      </span>
    )}
  </button>
);


export const Recording = ({ className = '', solid = false, onClick, ...props }: React.HTMLAttributes<HTMLButtonElement> & { solid: boolean }): React.ReactElement => (
  <button
    type='button'
    className={cx(className, 'x-pseudo p-4px')}
    onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
      event.stopPropagation();
      event.preventDefault();
      onClick?.(event);
    }}
    {...props}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M20.3478 19.6957H15.9288C18.9539 17.9741 21 14.7225 21 11C21 5.48605 16.5141 1 11 1C5.48581 1 1 5.48605 1 11C1 16.4166 5.32956 20.838 10.7095 20.9926C10.7338 20.9954 10.7576 21 10.7826 21H20.3478C20.7079 21 21 20.7081 21 20.3478C21 19.9876 20.7078 19.6957 20.3478 19.6957ZM14.7283 6.58824C15.6616 6.04926 16.8615 6.3702 17.4011 7.30434V7.30457C17.9404 8.23887 17.619 9.43773 16.6849 9.97695C15.7518 10.5159 14.5528 10.1978 14.0125 9.26066C13.4728 8.32699 13.7942 7.12793 14.7283 6.58824ZM7.27163 15.4118C6.33893 15.9504 5.13921 15.6311 4.59882 14.6957C4.0596 13.7611 4.38101 12.5623 5.31511 12.023C6.25019 11.4829 7.44803 11.8036 7.98749 12.7393C8.5267 13.6732 8.20573 14.8721 7.27163 15.4118ZM7.98753 9.26066C7.44823 10.1961 6.25046 10.5172 5.31515 9.97695C4.38105 9.43773 4.05964 8.23887 4.59886 7.30457C5.13769 6.37027 6.33675 6.04926 7.27167 6.58809C8.20573 7.12793 8.5267 8.3268 7.98753 9.26066ZM11 18.3913C9.92112 18.3913 9.04346 17.5136 9.04346 16.4348C9.04346 15.3559 9.92112 14.4782 11 14.4782C12.0788 14.4782 12.9565 15.3559 12.9565 16.4348C12.9565 17.5136 12.0788 18.3913 11 18.3913ZM11 7.52176C9.92112 7.52176 9.04346 6.6441 9.04346 5.56523C9.04346 4.48637 9.92112 3.60871 11 3.60871C12.0788 3.60871 12.9565 4.48637 12.9565 5.56523C12.9565 6.6441 12.0788 7.52176 11 7.52176ZM14.7283 15.412C13.7942 14.8721 13.4728 13.673 14.0125 12.7391C14.5512 11.8051 15.7477 11.4823 16.6849 12.023C17.619 12.5623 17.9404 13.7611 17.4011 14.6954V14.6957C16.862 15.6289 15.664 15.9515 14.7283 15.412Z"
      fill={solid ? 'white' : 'transparent' } stroke="white" strokeWidth="1.5"/>
    </svg>
  </button>
);
